import { render, staticRenderFns } from "./FileItem.vue?vue&type=template&id=62a6150b&scoped=true&lang=pug"
import script from "./FileItem.vue?vue&type=script&lang=ts"
export * from "./FileItem.vue?vue&type=script&lang=ts"
import style0 from "./FileItem.vue?vue&type=style&index=0&id=62a6150b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a6150b",
  null
  
)

export default component.exports